import { createSelector } from 'reselect';
import { RootState } from '..';

const _getUserState = ({ userReducer }: RootState) => userReducer;
export const getUserState = createSelector(_getUserState, state => state);
export const getUser = createSelector(getUserState, state => state.user);
export const getCurrentUserLocation = createSelector(
  getUserState,
  state => state.currentLocation
);
